(function (angular) {
    'use strict';

    angular.module('shared')
        .controller('dummySidebarController', ['$scope', 'jwtService', 'sharedDataService', 'apiSpacePicker', '$state', 'utilService', '$sce', 'companyBillingService', '$uibModal', 'myProfileService',
            function ($scope, jwtService, sharedDataService, apiSpacePicker, $state, utilService, $sce, companyBillingService, $uibModal, myProfileService) {

                $scope.impersonate = jwtService.payload.impersonatorUserName;
                $scope.login = jwtService.payload.sub;
                $scope.checkState = function () {
                    return $state.current.name == 'apiSpace';
                };
                $scope.jwt = jwtService;
                $scope.apiSpacePicker = apiSpacePicker;
                $scope.pickedApiSpace = null;

                $scope.$on('apiSpacesUpdate:picked', function () {
                    $scope.pickedApiSpace = apiSpacePicker.getApiSpaces()[apiSpacePicker.getPicked()];

                    var currentApiSpaceId = $scope.pickedApiSpace.id;
                    console.info("Switched apispace to " + currentApiSpaceId);
                });

                $scope.signout = function () {
                    jwtService.clear();
                    sharedDataService.clearCache();
                    $state.go('login');
                };

            }]);

})(window.angular);
